import { render, staticRenderFns } from "./LongStringLink.vue?vue&type=template&id=64d82033&"
import script from "./LongStringLink.vue?vue&type=script&lang=js&"
export * from "./LongStringLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports